import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import BunkeyApi from '../../api/BunkeyAPI'
import { Form, Button, Icon, Upload, Tooltip } from 'antd'
import { getAssetType, ENDPOINT } from '../../utils'
import { userAvatarConfig } from '../../actions/AuthAction'
import axios from 'axios'
import { sendNotification } from '../../utils/index'
import bunkeyAvatar1 from '../../assets/avatars/bunkey-avatar-02.png'
import bunkeyAvatar2 from '../../assets/avatars/bunkey-avatar-03.png'
import bunkeyAvatar3 from '../../assets/avatars/bunkey-avatar-04.png'
import bunkeyAvatar4 from '../../assets/avatars/bunkey-avatar-05.png'
import bunkeyAvatar5 from '../../assets/avatars/bunkey-avatar-06.png'
import bunkeyAvatar6 from '../../assets/avatars/bunkey-avatar-07.png'
import bunkeyAvatar7 from '../../assets/avatars/bunkey-avatar-08.png'
import bunkeyAvatar8 from '../../assets/avatars/bunkey-avatar-09.png'
import bunkeyAvatar9 from '../../assets/avatars/bunkey-avatar-10.png'
import bunkeyAvatar10 from '../../assets/avatars/bunkey-avatar-11.png'
import bunkeyAvatar11 from '../../assets/avatars/bunkey-avatar-12.png'
import bunkeyAvatar12 from '../../assets/avatars/bunkey-avatar-13.png'
import bunkeyAvatar13 from '../../assets/avatars/bunkey-avatar-14.png'
import bunkeyAvatar14 from '../../assets/avatars/bunkey-avatar-15.png'
import bunkeyAvatar15 from '../../assets/avatars/bunkey-avatar-16.png'
import bunkeyAvatar16 from '../../assets/avatars/bunkey-avatar-17.png'
import bunkeyAvatar17 from '../../assets/avatars/bunkey-avatar-18.png'
import bunkeyAvatar18 from '../../assets/avatars/bunkey-avatar-19.png'
import bunkeyAvatar19 from '../../assets/avatars/bunkey-avatar-20.png'
import bunkeyAvatar20 from '../../assets/avatars/bunkey-avatar-21.png'
import bunkeyAvatar21 from '../../assets/avatars/bunkey-avatar-22.png'
import bunkeyAvatar22 from '../../assets/avatars/bunkey-avatar-23.png'
import bunkeyAvatar23 from '../../assets/avatars/bunkey-avatar-24.png'
import bunkeyAvatar24 from '../../assets/avatars/bunkey-avatar-25.png'
import bunkeyAvatar25 from '../../assets/avatars/bunkey-avatar-26.png'

import './change-avatar.css'


export class ConfigUser extends Component {
  constructor(props) {
    super(props)

    this.avatarImages = [
      bunkeyAvatar1,
      bunkeyAvatar2,
      bunkeyAvatar3,
      bunkeyAvatar4,
      bunkeyAvatar5,
      bunkeyAvatar6,
      bunkeyAvatar7,
      bunkeyAvatar8,
      bunkeyAvatar9,
      bunkeyAvatar10,
      bunkeyAvatar11,
      bunkeyAvatar12,
      bunkeyAvatar13,
      bunkeyAvatar14,
      bunkeyAvatar15,
      bunkeyAvatar16,
      bunkeyAvatar17,
      bunkeyAvatar18,
      bunkeyAvatar19,
      bunkeyAvatar20,
      bunkeyAvatar21,
      bunkeyAvatar22,
      bunkeyAvatar23,
      bunkeyAvatar24,
      bunkeyAvatar25,
    ]
    this.state = {
      showSizeLimitTxt: null, // Mostrar texto de limite de tamaño de img
      disableSubmitButton: true, // Deshabilitar boton de 'cambiar'
      fileList: null, // Guarda la img cargada en el drawer si es menor a 2MB
      previewImage: null, // Guarda imagen cargada para obtener signature
      futureFileURL: null, // Guarda futura url que se enviará a redux
      url: null, // Guarda url de la imagen al obtener signature
      avatarArr: null, //Guarda avatars que se veran en el drawer
    }
  }

  componentDidMount() {
    const newAvatars = this.avatarImages.map((value, k) => {
      return (
        <img
          alt='avatar'
          src={value}
          key={k}
          style={{ width: '60px', margin: '7px', cursor: 'pointer' }}
          onClick={() => this.props.userAvatarConfig(value)} />
      )
    })
    this.setState({
      avatarArr: newAvatars
    })
  }

  handleUrlSignaturePreview = (value) => {
    const { userId } = this.props

    // 2097152bytes equivalen a 2MB
    if (value.size < 2097152) {
      let list = [value]
      this.setState({
        disableSubmitButton: false,
        showSizeLimitTxt: false,
        fileList: list
      })

      BunkeyApi({
        url: 'url-signature',
        method: 'POST',
        data: {
          clientId: userId,
          mimeType: value.type,
          extention: getAssetType(value.type)
        }
      }).then(resp => {
        this.setState({
          previewImage: {
            file: value,
          },
          futureFileURL: resp.data.futureFileURL,
          url: resp.data.url,
        })
      }).catch(err => {
        this.setState({
          previewImage: null
        })
      })

      return false
    } else {
      this.setState({
        disableSubmitButton: true,
        showSizeLimitTxt: true,
        fileList: []
      })
    }
    return false
  }

  handleSubmit = () => {
    const { previewImage, futureFileURL, url } = this.state
    const { intl } = this.props

    if (previewImage !== null) {
      let promises = []
      promises.push(new Promise(() => {
        const client = axios.create({
          baseURL: ENDPOINT
        })
        client.put(url,
          previewImage.file,
          {
            headers: {
              'Content-Type': previewImage.file.type,
              'Content-Disposition': 'attachment'
            }
          })
          .then(resp => {
            this.props.userAvatarConfig(futureFileURL)
          })
          .catch(err => {
            sendNotification('error', intl, intl.formatMessage({ id: 'try_again' }))
            this.setState({
              disableSubmitButton: true,
              fileList: [],
            })
          })
      }))
    } else {
      sendNotification('error', intl, intl.formatMessage({ id: 'try_again' }))
      this.setState({
        disableSubmitButton: true,
        fileList: [],
        isFetching: false
      })
    }
  }

  handleOnRemovePreview = () => {
    this.setState({
      disableSubmitButton: true,
      showSizeLimitTxt: false,
      previewImage: null,
      fileList: []
    })
  }

  handleCancel = () => {
    this.handleOnRemovePreview()
    this.props.handleHideAvatar()
  }

  render() {
    const { showSizeLimitTxt, fileList, disableSubmitButton, avatarArr } = this.state
    const { newColor, isFetching } = this.props

    return (
      <React.Fragment>
        <Form.Item className='config-title' >
          <span>{<FormattedMessage id="settings_select_avatar" />}</span>
        </Form.Item>
        <Form.Item>
          {avatarArr}
        </Form.Item>
        <Form.Item className='config-title' >
          <span>{<FormattedMessage id="upload_new_avatar" />}</span>
        </Form.Item>
        {showSizeLimitTxt && <Form.Item className='config-warning' >
          <span>{<FormattedMessage id="image_than_equal" />}</span>
        </Form.Item>}
        <Form.Item style={{ marginBottom: '5px' }} >
          <Upload
            accept='.png, .jpg, .jpeg, .gif'
            beforeUpload={this.handleUrlSignaturePreview}
            onRemove={this.handleOnRemovePreview}
            fileList={fileList}
            listType='picture'>
            <Button
              style={{ marginRight: '10px', color: newColor, borderColor: newColor }}>
              <Icon type="upload" />{<FormattedMessage id="upload_avatar" />}
            </Button>
            <Tooltip title={<FormattedMessage id="tooltip_image" />}>
              <Icon type="info-circle" theme="outlined" />
            </Tooltip>
          </Upload>
          {disableSubmitButton && <Button
            loading={isFetching}
            type="primary"
            disabled={disableSubmitButton}
            onClick={this.handleSubmit}>{<FormattedMessage id="change" />}</Button>}
          {!disableSubmitButton && <Button
            loading={isFetching}
            type="primary"
            style={{ color: '#fff', backgroundColor: newColor, borderColor: newColor }}
            onClick={this.handleSubmit}>{<FormattedMessage id="change" />}</Button>}
          <Button
            type='deafult'
            style={{ color: newColor, borderColor: newColor, marginLeft: '10px' }}
            onClick={this.handleCancel}>{<FormattedMessage id="cancel_button" />}<Icon type="close" /></Button>
        </Form.Item>
      </React.Fragment>)
  }
}

const mapStateToProps = state => {
  return {
    userId: state.authUser.user._id,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isFetching: state.authUser.user.changeAvatarIsFetching
  }
}

const mapDispatchToProps = {
  userAvatarConfig
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigUser)))

